<!-- 总表 -->
<template>
<div>
    <div class="page-form" v-if="isShow">
        <PageBack :title="title" />
        <!-- <el-button class="mg-t-20" @click="handleExport" type="success" size="medium">导出成绩</el-button> -->
        <div class="custom-table2">            
            <div class="size20 center mg-b-10 bold">{{ pubTitle }}</div>            
            <el-table :data="tableData" class="custom-table" 
                :row-class-name="tableRowClassName"
                border>
                <el-table-column prop="rank" label="名次" align="center" width="70px"/>                 
                <el-table-column prop="username" label="选手" align="center"/> 
                <el-table-column prop="partnerName" label="搭档" align="center" v-if="pubType ==='2'"/> 
                <el-table-column prop="company" label="协会(俱乐部)" align="center"/> 
                <el-table-column v-for="(item,index) in roundLength " :key="item+'a'" :label="`第${index+1}轮`" align="center">            
                    <!-- <el-table-column label="对手"  v-if="pubType === '2'" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].playersId2}}</template>
                    </el-table-column>  
                    <el-table-column label="同桌"  v-if="pubType === '1'" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].playersId}}</template>
                    </el-table-column> -->
                    <el-table-column label="得分" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].score}}</template>
                    </el-table-column> 
                    <el-table-column label="级差分" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].minus}}</template>
                    </el-table-column>  
                </el-table-column>     
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import pagination  from '@/components/Pagination'
import Breadcrumb from '@/components/Breadcrumb'
import PageBack from '@/components/PageHeader'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
    components:{
        pagination,
        Breadcrumb,
        PageBack
    },
    data(){
        return{
            roundLength: 1, 
            isShow: false,
            tableData:[],
            tableHeaders: [
                {label: '积分', prop: 'score'},
                {label: '胜轮次', prop: 'winNum'},
                {label: '级差总分', prop: 'totalRank'},
                {label: '升级数', prop: 'number'},
                {label: '搭档总分', prop: 'partnerScore'},
                {label: '对手总分', prop: 'totalPlayers'},
                {label: '对手总级差分', prop: 'totalMinusPlayers'},               
                {label: '搭档总级差分', prop: 'partnerRank'},
            ],
            dynamicHeaders:[],
            pubTitle: '',
            exportData: [],
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
        publishId(){
            return this.$route.query.id
        },
        pubType(){
            return this.$route.query.type
        } 
    },
    created(){
        // console.log(typeof this.pubType)
    },
    mounted() {
        if(this.publishId){
            this.getQuery()
        }
        this.initData()
    },
    methods: {
        tableRowClassName({row, rowIndex}){
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        getQuery(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    this.pubTitle = result['主题']
                }
            })
        },
        initData(){
            let params = {
                opcode: this.$code.RankScore,
                i_serial_mark: this.publishId
            }
            this.$api._requestAPI(params).then(async res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        let result = res.Data.DataTable
                        let arr = result.map(item=>{                    
                            return{
                                playersId: item['选手编号'],
                                username: item['选手'],
                                rank: item['名次'],
                                score: item['积分'],
                                number: item['升级数'],                           
                                totalRank: item['级差总分'],
                                totalPlayers: item['对手总分'],
                                totalMinusPlayers: item['对手总级差分'],
                                partnerScore: item['搭档总分'],
                                partnerRank: item['搭档总级差分'],
                                partnerName: item['搭档'],
                                totalScore: item['累计分'],
                                winNum: item['胜轮次'],    
                                company: item['单位'],                        
                            }
                        })                    
                    
                    let newArr = [] 
                    let exportDataArr = []
                    for (const obj of arr) {
                        let roundList = await this.getRoundList(obj.playersId)
                        this.roundLength = roundList.length             
                        newArr.push({
                            round: roundList,
                            ...obj
                        })
                        // exportDataArr.push(roundList)
                    }   
                    // console.log(newArr)
                    // console.log(exportDataArr)

                    this.tableData = newArr
                    let outputArry = this.$help.transformObjectToArrayTotal(result[0])
                    this.isShow = true
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                    // 过滤出至少有一个非空值的字段
                    let filterArrNew= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));
                    // 第一种方法 固定表头
                    // this.dynamicHeaders = this.tableHeaders.filter(i=>filterArrNew.includes(i.prop))
                    // 第二种方法 动态获取表头
                    this.dynamicHeaders = outputArry.filter(i=>filterArrNew.includes(i.prop))
                    // let resultObj = JSON.parse(JSON.stringify(result))
                        // console.log(exportDataArr[0])
                        // let newExportArr = exportDataArr.map((i,index)=>{
                        //     return{
                        //         '得分':  i[index].score,
                        //         '级差分': i[index].minus,
                        //     }
                        // })
                        // console.log(newExportArr)
                        // setTimeout(()=>{
                        //     this.exportData = resultObj.map((item,index)=>{                           
                        //         return{
                        //             ...item,                                 
                        //             ...exportDataArr[index]             
                        //         }
                        //     })
                        //     console.log('===2',this.exportData)
                        // },1000)                   
                    }else{
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        getRoundList(num){
            return new Promise((resolve,reject)=>{
                let params = {
                    opcode: this.$code.RankScorePartner,
                    i_serial_mark: this.publishId,
                    i_players_number: num
                }
                this.$api._requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable  
                        let arr = result.map(item=>{
                            return{
                                round:item['轮数'],
                                // playersId: item['同桌'],
                                // playersId2: item['对手'],
                                score: item['成绩'],
                                minus: item['级差分'],
                            }
                        })
                        this.roundLength = arr.length
                        resolve(arr)
                    }
                })               
            })
        },
        // 导出表格要用到的数据
        getRoundListExport(num){
            return new Promise((resolve,reject)=>{
                let params = {
                    opcode: this.$code.RankScorePartner,
                    i_serial_mark: this.publishId,
                    i_players_number: num
                }
                this.$api._requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable  
                        let arr = result.map(item=>{
                            return{
                                '得分': item['成绩'],
                                '级差分': item['级差分'],
                            }
                        })
                        this.roundLength = arr.length
                        resolve(arr)
                    }
                })               
            })
        },
         // 导出表格
         handleExport(){
            // 假设有一个表格数据的数组
            // console.log(this.exportData)
            // aoa_to_sheet array
            // const data = [
            //     ["选手编号","选手姓名", "搭档姓名", "选手手机号","搭档手机号","协会（俱乐部）"],
            //     []
            // ];
        
            // 将数据转换为工作表
            const worksheet = XLSX.utils.json_to_sheet(this.exportData);
        
            // 创建工作簿并添加工作表
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        
            // 生成Excel文件
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        
            // 使用blob和FileReader创建一个Blob URL   type: application/octet-stream
            const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream;charset=UTF-8' });
            const blobUrl = window.URL.createObjectURL(dataBlob);
        
            // 使用saveAs下载文件
            saveAs(dataBlob, '成绩表.xlsx');
        
            // 清理
            window.URL.revokeObjectURL(blobUrl);
        },
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.custom-table >>> .el-table__cell{
    font-size: 20px;
    padding: 0 !important;
    color:#000
}  
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
</style>


// WEBPACK FOOTER //
// src/views/playerScore/totalScore.vue